import api from "../../apis/api";

const event = {
  state: {
    eventData: {},
    loadingTickets: true,
    showTicketButton: false,
    showSubtitle: false,
  },
  getters: {
    getEventData: (state) => state.eventData,
    getLoadingTicketsState: (state) => state.loadingTickets,
    getTicketButtonState: (state) => state.showTicketButton,
    getShowSubtitleState: (state) => state.showSubtitle,
  },
  mutations: {
    SET_EVENT_DATA(state, data) {
      state.eventData[data.nid] = data;
    },
    SET_LOADING_TICKETS(state, value) {
      state.loadingTickets = value;
    },
    SET_TICKET_BUTTON(state, value) {
      state.showTicketButton = value;
    },
    SET_SHOW_SUBTITLE(state, value) {
      state.showSubtitle = value;
    },
  },
  actions: {
    fetchEventData({ commit }, nid) {
      commit("SET_LOADING_TICKETS", true);
      api.getEvent(nid).then((response) => {
        commit("SET_EVENT_DATA", response.data);
        commit("SET_LOADING_TICKETS", false);
      });
    },
    showTicketButton({ commit }) {
      commit("SET_TICKET_BUTTON", true);
    },
    showSubtitle({ commit }) {
      commit("SET_SHOW_SUBTITLE", true);
    },
  },
};

export default event;
